var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnify1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 640,
    transform: "translate(-111 -425)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96,
    y: -17,
    width: 330,
    height: 50,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0625 13.625C10.6869 13.625 13.625 10.6869 13.625 7.0625C13.625 3.43813 10.6869 0.5 7.0625 0.5C3.43813 0.5 0.5 3.43813 0.5 7.0625C0.5 10.6869 3.43813 13.625 7.0625 13.625Z",
    stroke: "#E60121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7021 11.7031L15.4991 15.5",
    stroke: "#E60121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -96,
    y: -17,
    width: 330,
    height: 50,
    rx: 5,
    stroke: "#E60121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 640,
    fill: "white",
    transform: "translate(-111 -425)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify1);
export default __webpack_public_path__ + "static/media/magnify-1.d339569e751b43f2e1d2d95e8fa4eca2.svg";
export { ForwardRef as ReactComponent };